// src/api/questions/questionsApi.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const checkQuestionsExist = async (projectId) => {
    try {
        const response = await axios.get(`${API_URL}/questions/check?project_id=${projectId}`);
        return response.data.exists;
    } catch (error) {
        console.error('Error checking questions existence:', error.message);
        return false;
    }
};

export const saveAssessment = async (projectId, difficulty, testType, sections, questionCounts, totalTime, subjectiveQuestions, objectiveQuestions, anchorQuestion, sectionMarks, marksPerQuestion,v) => {
    try {
        const response = await axios.post(`${API_URL}/questions/save`, {
            projectId,
            difficulty,
            testType,
            sections,
            questionCounts,
            totalTime,
            anchorQuestion,
            subjectiveQuestions,
            objectiveQuestions,
            total_marks_per_section: {
                conversational: sectionMarks.conversational,
                subjective: sectionMarks.subjective,
                objective: sectionMarks.objective,
            },
            marks_per_question: {
                conversational: marksPerQuestion.conversational,
                subjective: marksPerQuestion.subjective,
                objective: marksPerQuestion.objective,
            },
            v
        });
        return response.data;
    } catch (error) {
        console.error('Error saving assessment:', error.message);
        throw error;
    }
};

export const fetchRandomizedQuestions = async (projectId, difficulty, subjectiveCount, objectiveCount, sections) => {
    try {
        const response = await axios.get(`${API_URL}/questions/randomized`, {
            params: {
                project_id: projectId,
                difficulty,
                subjectiveCount,
                objectiveCount,
                sections: JSON.stringify(sections),
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching randomized questions:', error.message);
        throw error;
    }
};

export const getAssessmentDetails = async (projectId) => {
    try {
        // console.log(`Fetching assessment details for projectId: ${projectId}`);
        const response = await axios.get(`${API_URL}/questions/details?project_id=${projectId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching assessment details:', error.message);
        throw error;
    }
};

export const fetchbackendQuestions = async (projectId) => {
    return await axios.get(`${process.env.REACT_APP_API_URL}/questions/${projectId}`);
};

export const getQuestionCodes = async (projectId) => {
    try {
        const response = await axios.get(`${API_URL}/questions/codes`, {
            params: { project_id: projectId }, // Ensure project_id is passed here
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching question codes:', error.message);
        throw error;
    }
};

export const updateAssessmentStatus = async (questionCode, status, userId) => {
    //console.log('API Call Payload:', { question_code: questionCode, status, user_id: userId });
    try {
        const response = await axios.post(`${API_URL}/questions/status`, {
            question_code: questionCode,
            status,
            user_id: userId,
        });
        return response.data;
    } catch (error) {
        console.error('Error updating assessment status:', error.message);
        throw error;
    }
};